import React from 'react'
import { Header } from '@pcln/whitelabel-components'
import { Partner } from '../../../types'

const PartnerHeader = ({ partner }: { partner: Partner }) => (
  <div id="exp-hdr">
    <div
      className="fixed"
      id={`${partner.partnerCode}-global-header`}
      data-testid={`${partner.partnerCode}-global-header`}
    >
      <Header partner={partner} />
    </div>
  </div>
)

export default PartnerHeader
